export const BEHAVIORS = [
    "No Behavior Observed",
    "Absent Mindedness",
    "Aggression/Assault",
    "Agoraphobia",
    "Alcohol Abuse/Intoxication",
    "Anal Insertion",
    "Avoidant Behavior",
    "Bedwetting",
    "Breaking Personal Boundaries",
    "Bullying",
    "Borrowing without Permission",
    "Bossiness", 
    "Coprophagia",
    "Cutting Behavior",
    "COVID-19 Defiant Behavior",
    "Dangerous Car Behavior",
    "Darting into Traffic",
    "Disruption",
    "Disrespectful/Insolent Behavior (Sassiness)",
    "Doctor Seeking Behavior", 
    "Dropping to the Floor",
    "Drug Seeking",
    "Drug Abuse/Intoxication",
    "Dysphagia (Difficulty Swallowing/Choking)",
    "Emotional Outburst",
    "Exhibition",
    "Excessive Eating",
    "Excessive Drinking",
    "Excessive Calling/Texting",
    "Excessive Requests",
    "Exploitation",
    "Food Seeking",
    "Finger Biting",
    "False Accusation",
    "Feigning Illness",
    "Forgery",
    "Fraudulent Behavior",
    "Gang-Related Behavior",
    "Grabbing",
    "Gossiping",
    "Gyrating",
    "Hallucinations",
    "Hiding Contraband",
    "Infidelity",
    "Inappropriate Sexual Behaviors",
    "Inappropriate Defecation/Encopresis",
    "Inappropriate Demands",
    "Impulsivity (Impulsive Behavior)",
    "Inappropriate Hugging Behavior",
    "Inappropriate Social Behaviors",
    "Inappropriate Urination/Enuresis",
    "Inappropriate Attention Seeking Behavior",
    "Inappropriate Touching",
    "Invading Personal Space",
    "Isolation",
    "Joyriding",
    "LOA",
    "Lip Smacking",
    "Lying/Manipulation",
    "Neglect",
    "Nose Picking",
    "Noncompliance",
    "Obsessive Behavior",
    "Odd-Licking Behavior",
    "Over-Indulgence BX",
    "Obsessive-Compulsive Behavior",
    "Pacing Behavior",
    "Persevering Speech",
    "Physical Abuse",
    "Pica/Consuming Toxins",
    "Posturing/Physical Threats/Charging",
    "Poor Hygiene Behavior",
    "Poor Toileting BX (Not Wiping Correctly)",
    "Positive Behavior",
    "Property Destruction",
    "Precursor Behavior (as Individually Defined",
    "Psychological Distress",
    "Prostitution",
    "Public Masturbation",
    "Refusal to Get Out of the Vehicle",
    "Refusal to Transition",
    "Refusals",
    "Running Away/Elopement/AWOL Behavior",
    "Refusal to Take Medications",
    "Racist Type Behavior",
    "Screaming",
    "Self-Induced Vomiting",
    "Self-Stimulation",
    "Self Injurious Behaviors",
    "Sexist Type Behavior",
    "Sexually Acting Out",
    "Sexual Deviant Behavior",
    "Sexual Comments",
    "Spitting Aimlessly",
    "Smearing Fecal Matter",
    "Spitting at Others",
    "Sleep Disturbance/Insomnia",
    "Skin Picking Behavior",
    "Stripping Behavior",
    "Suicidal Behavior/Ideation",
    "Staring/Glaring/Scowling Behavior",
    "Targeting Staff Members",
    "Triangulation",
    "Teasing/Bothering",
    "Tantrum Behavior",
    "Trichotillomania/Hair Pulling",
    "Theft/Stealing",
    "Thumb-Sucking Behavior",
    "Transvestism",
    "Trespassing",
    "Unsafe/Risky Behavior",
    "Unwanted Kissing Behavior",
    "Verbal Aggression",
    "Verbal Threats",
    "Victim Grooming Behavior",
    "Voyeurism",
    "Wandering",
    "Whining",
    "Wearing Dirty Attire",
    "Womanizing"
]